import { get_axios_instance, api_variables, errorHandler } from '@/apis/variables.js';

var axios_instance = get_axios_instance(api_variables.SERVICE_UPLOAD_LOP_RLOP);
var axios_instance_loprlop = get_axios_instance(api_variables.SERVICE_CREATE_LOP_RLOP);
var axios_instance_month_data = get_axios_instance(api_variables.SERVICE_GET_MONTH_LOP_RLOP);
var axios_onsite_emp_template = get_axios_instance(api_variables.SERVICE_ONSITE_EMPLOYEE);
var axios_presigned_url= get_axios_instance(api_variables.SERVICE_PRESIGNED_URL);
var axios_taxoutsidepayroll_emp_template = get_axios_instance(api_variables.SERVICE_DOWNLOAD_TEMPLATE_TAXAFTERPAYROLL);
var axios_arrearoverride_emp_template = get_axios_instance(api_variables.SERVICE_ARREAROVERRIDE_EMPLOYEE);
var axios_installment_emp_template = get_axios_instance(api_variables.SERVICE_INSTALLMENT_EMPLOYEE);
var axios_workbasedays_template = get_axios_instance(api_variables.SERVICE_DOWNLOAD_WORKBASEDAYS_TEMPLATE);
var axios_arrearoverride_report = get_axios_instance(api_variables.SERVICE_DOWNLOAD_ARREAROVERIDES);

const _pk_name = "id";

const state = {
  data:[],
  lopRlopMonthData:[],
  lopsandrlops: {},
  isFetching: false,
  isSaving: false,
  isDeleting: false
};

const mutations = {
  set: (state, payload) => {
    state.data = payload;
    //console.log('fetched data', state.data)
  },

  setData: (state, payload) => {
    state.lopRlopMonthData = payload;
  },

  setLopsandRlops: (state, payload) => {
    if(payload) {
      state.lopsandrlops = payload;
    }
    //console.log('fetched lopsandrlops', state.lopsandrlops)
  },

  addEmployee: (state, payload) => {
    //console.log('payload data from store', payload)
    state.lopsandrlops = payload;
    //console.log('lopsandrlops data', state.lopsandrlops);
    //console.log('state data', state.data);
    // state.data.push(payload);
  },

//   updateEmployeeById: (state, payload) => {
//     for(let i=0; i<state.data.length; i++) {
//       if(state.data[i][_pk_name] === payload.id) {
//         state.data.splice(i, 1, payload);
//       }
//     }
//   },

//   removeEmployeeById: (state, payload) => {
//     for (let i=0; i<state.data.length; i++){
//       if (state.data[i][_pk_name] == payload){
//         state.data.splice(i, 1);
//       }
//     }
//   },

  setFetching: (state, payload) => {
    state.isFetching = payload;
  },

  setSaving: (state, payload) => {
    state.isSaving = payload;
  },

  setDeleting: (state, payload) => {
    state.isDeleting = payload;
  },
}

const actions = {
  async fetchAll({commit}, [id, payload]) {
      //console.log("[state/payroll/lopsandrlops/fetchAll] Calling API...");
    try {
      commit("setFetching", true);
      let res = await axios_instance.get(`/:`+id, payload);
      commit("setFetching", false);
      //console.log("[state/payroll/lopsandrlops/fetchAll] res: ", res);
      if(res.status == 200) {
        commit("set", payload);
      }
      return res;
    }catch (err) {
      //console.log(err)
      throw errorHandler(err.response);
      //  return new Error(err.message)
  }
    
  },

async fetchLopandRlop({commit}, payload) {
  //console.log("[state/payroll/lopsandrlops/fetchlopsandrlops] Calling API...");
  //console.log('payload paygroup id', payload)
try {
  commit("setFetching", true);
  let res = await axios_instance.get(`/`, {
    params: {
      paygroupId: payload
    }
  });
  commit("setFetching", false);
  //console.log("[state/payroll/lopsandrlops/fetchAll] res: ", res);
  if(res.status == 200) {
    commit("setLopsandRlops", res.data.rows);
  }
  return res;
}catch (err) {
  //console.log(err)
  throw errorHandler(err.response);
  //  return new Error(err.message)
}
},

  async create({commit}, payload) {
      //console.log("[state/payroll/lopsandrlops/create] Adding...", payload);
    try {
      commit("setSaving", true);
      let res = await axios_instance_loprlop.post('', payload);
      commit("setSaving", false);
      //console.log("[state/payroll/lopsandrlops/create] res: ", res);
      if(res.status == 200) {
        commit("addEmployee", payload);
      }
      return res;
    }catch (err) {
      //console.log("im in");
      commit("setSaving", false);
      throw errorHandler(err.response);
  }
  },
  async createPreSigned({commit}, payload) {
    //console.log("[state/payroll/lopsandrlops/create] Adding...", payload);
  try {
    commit("setSaving", true);
    let res = await axios_presigned_url.post('', payload);
    commit("setSaving", false);
    //console.log("[state/payroll/lopsandrlops/create] res: ", res);
    if(res.status == 200) {
      commit("addEmployee", payload);
    }
    return res;
  }catch (err) {
    //console.log("im in");
    commit("setSaving", false);
    throw errorHandler(err.response);
}
},

  
  async update({commit}, payload) {
      //console.log("[state/payroll/lopsandrlops/update] Updating... Display payload", payload);
    try {
      commit("setSaving", true);
      let res = await axios_instance.put(`/${payload.id}`, payload);
      commit("setSaving", false);
      //console.log("[state/payroll/lopsandrlops/update] res: ", res);
      if(res.status == 200) {
        commit("updateEmployeeById", res.data);
      }
      return res;
    }catch (err) {
      //console.log(err)
      throw errorHandler(err.response);
      //  return new Error(err.message)
  }
  },

  async downloadOnsiteTemplates({ commit }, payload) {
    try {
      console.log("Entry, payload", payload)
      let res = await axios_onsite_emp_template.get('', {
        params: {
          le_id: payload.le_id,
          }
      })
      if (res.data.status) {
        const link = document.createElement("a");
        link.href = res.data.payload;
        link.setAttribute("download", "Onsite_Employee_Bulk_Template.xlsx"); //or any other extension
        document.body.appendChild(link);
        link.click();
    }
    } catch (err) {
      throw errorHandler(err.response);
    }
},

async downloadTaxoutsidePayrollTemplates({ commit }, payload) {
  try {
    console.log("Entry, payload", payload)
    let res = await axios_taxoutsidepayroll_emp_template.get('', {
      params: {
        le_id: payload.le_id,
        }
    })
    if (res.data.status) {
      const link = document.createElement("a");
      link.href = res.data.payload;
      link.setAttribute("download", "Taxoutsidepayroll_Employee_Bulk_Template.xlsx"); //or any other extension
      document.body.appendChild(link);
      link.click();
  }
  } catch (err) {
    throw errorHandler(err.response);
  }
},

async downloadArrearOverrideTemplates({ commit }, payload) {
  try {
    console.log("Entry, payload in arrearoverride", payload)
    let res = await axios_arrearoverride_emp_template.get('', {
      params: {
        le_id: payload.le_id,
        financial_year : payload.financial_year,
        month: payload.month
        }
    })
    if (res.data.status) {
      const link = document.createElement("a");
      link.href = res.data.payload;
      link.setAttribute("download", "ArrearOverrides_Employee_Bulk_Template.xlsx"); //or any other extension
      document.body.appendChild(link);
      link.click();
  }
  } catch (err) {
    throw errorHandler(err.response);
  }
},
async downloadArrearOverrideReport({ commit }, payload) {
  try {
    let res = await axios_arrearoverride_report.get('', {
      params: {
        legal_entity_id: payload.le_id,
        arrear_month: payload.month,
        year: payload.year
        }
    })
    if (res.data.status) {
      const link = document.createElement("a");
      link.href = res.data.payload;
      link.setAttribute("download", "ArrearOverrides_Reports.xlsx");
      document.body.appendChild(link);
      link.click();
  }
  } catch (err) {
    throw errorHandler(err.response);
  }
},

async downloadInstallmentTemplates({ commit }) {
  try {
    let res = await axios_installment_emp_template.get('', {
      // params: {
      //   le_id: payload.le_id,
      //   }
    })
    if (res.data.status) {
      const link = document.createElement("a");
      link.href = res.data.payload;
      link.setAttribute("download", "Installment_Employee_Bulk_Template.xlsx"); //or any other extension
      document.body.appendChild(link);
      link.click();
  }
  } catch (err) {
    throw errorHandler(err.response);
  }
},

async downloadWorkBaseDayTemplates({ commit }, payload) {
  try {
    let res = await axios_workbasedays_template.get('', {
      params: {
        le_id: payload.le_id,
        }
    })
    if (res.data.status) {
      const link = document.createElement("a");
      link.href = res.data.payload;
      link.setAttribute("download", "Onsite_Employee_Bulk_Template.xlsx"); //or any other extension
      document.body.appendChild(link);
      link.click();
  }
    return res;
  } catch (err) {
    throw errorHandler(err.response);
  }
},

  async getLopData({commit}, payload) {
    //console.log("[state/payroll/lopsandrlops/fetchAll] Calling API...");
    try {
      commit("setFetching", true);
      let res = await axios_instance_month_data.get(`/`, {
        params: 
          payload
      });
      commit("setFetching", false);
      if(res.status == 200) {
        commit("setData", [res.data.payload.data, payload]);
      }
      return res;
    }catch (err) {
      //console.log(err)
      throw errorHandler(err.response);
    }
  },

  async delete({commit}, payload) {
    //console.log("[state/payroll/lopsandrlops/delete] Payload:", payload);
    //console.log("[state/payroll/lopsandrlops/delete] Payload:", `/${payload.id}`);
    try {
      commit("setDeleting", true);
      let res = await axios_instance.delete(`/${payload.id}`);
      commit("setDeleting", false);
      if (res.status == 200){
        commit("removeEmployeeById", payload.id);
      }
    }catch (err) {
      //console.log(err)
      throw errorHandler(err.response);
      //  return new Error(err.message)
  }
  }
}

export default {
  namespaced: true,
  state, mutations, actions
}
